import React, { useState } from 'react';

const MyWorkflows = () => {
  const [workflows] = useState([
    {
      id: 1,
      name: 'Customer Support Automation',
      description: 'Automated ticket routing and response system',
      status: 'active',
      lastRun: '2 hours ago',
      executions: 1247,
      successRate: 98.5,
      category: 'Support'
    },
    {
      id: 2,
      name: 'Lead Qualification Pipeline',
      description: 'Automated lead scoring and nurturing workflow',
      status: 'active',
      lastRun: '15 minutes ago',
      executions: 892,
      successRate: 94.2,
      category: 'Marketing'
    },
    {
      id: 3,
      name: 'Data Sync & Validation',
      description: 'Cross-platform data synchronization workflow',
      status: 'paused',
      lastRun: '1 day ago',
      executions: 2156,
      successRate: 99.1,
      category: 'Data'
    },
    {
      id: 4,
      name: 'Invoice Processing',
      description: 'Automated invoice generation and approval',
      status: 'active',
      lastRun: '30 minutes ago',
      executions: 567,
      successRate: 96.8,
      category: 'Finance'
    }
  ]);

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'text-emerald-500 bg-emerald-500/10';
      case 'paused': return 'text-yellow-500 bg-yellow-500/10';
      case 'error': return 'text-red-500 bg-red-500/10';
      default: return 'text-slate-500 bg-slate-500/10';
    }
  };

  const getCategoryColor = (category) => {
    switch (category) {
      case 'Support': return 'text-blue-500 bg-blue-500/10';
      case 'Marketing': return 'text-purple-500 bg-purple-500/10';
      case 'Data': return 'text-orange-500 bg-orange-500/10';
      case 'Finance': return 'text-emerald-500 bg-emerald-500/10';
      default: return 'text-slate-500 bg-slate-500/10';
    }
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-3xl font-black text-white tracking-tight">My Workflows</h2>
          <p className="text-[#92b7c9] mt-1">Manage and monitor your automated business processes.</p>
        </div>
        <button className="bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-lg font-semibold flex items-center gap-2 transition-colors">
          <span className="material-symbols-outlined">add</span>
          Create Workflow
        </button>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-primary/10 rounded-lg">
              <span className="material-symbols-outlined text-primary">account_tree</span>
            </div>
            <span className="text-xs text-emerald-500 font-bold">+3 this week</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Total Workflows</p>
          <h3 className="text-white text-2xl font-bold mt-1">24</h3>
        </div>

        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-emerald-500/10 rounded-lg">
              <span className="material-symbols-outlined text-emerald-500">play_arrow</span>
            </div>
            <span className="text-xs text-emerald-500 font-bold">18 active</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Active Workflows</p>
          <h3 className="text-white text-2xl font-bold mt-1">18</h3>
        </div>

        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-blue-500/10 rounded-lg">
              <span className="material-symbols-outlined text-blue-500">trending_up</span>
            </div>
            <span className="text-xs text-blue-500 font-bold">+12% vs last month</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Total Executions</p>
          <h3 className="text-white text-2xl font-bold mt-1">4.8K</h3>
        </div>

        <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#325567] rounded-xl p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="p-2 bg-purple-500/10 rounded-lg">
              <span className="material-symbols-outlined text-purple-500">check_circle</span>
            </div>
            <span className="text-xs text-purple-500 font-bold">97.2% avg</span>
          </div>
          <p className="text-[#92b7c9] text-sm font-medium">Success Rate</p>
          <h3 className="text-white text-2xl font-bold mt-1">97.2%</h3>
        </div>
      </div>

      {/* Workflows Table */}
      <div className="bg-white dark:bg-[#111c22] border border-slate-200 dark:border-[#233c48] rounded-xl overflow-hidden">
        <div className="p-6 border-b border-slate-200 dark:border-[#233c48]">
          <div className="flex justify-between items-center">
            <h3 className="text-white font-bold text-lg">Workflow Overview</h3>
            <div className="flex items-center gap-3">
              <div className="relative">
                <span className="material-symbols-outlined absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-sm">search</span>
                <input 
                  className="bg-slate-100 dark:bg-[#233c48] border-none rounded-lg pl-9 pr-4 py-2 text-sm focus:ring-1 focus:ring-primary text-white placeholder:text-slate-500 w-64" 
                  placeholder="Search workflows..." 
                  type="text"
                />
              </div>
              <button className="text-slate-400 hover:text-white p-2 rounded-lg hover:bg-[#233c48] transition-colors">
                <span className="material-symbols-outlined">filter_list</span>
              </button>
            </div>
          </div>
        </div>

        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-slate-50 dark:bg-[#1a2b35]">
              <tr>
                <th className="text-left py-4 px-6 text-xs font-bold text-slate-500 uppercase tracking-wider">Workflow</th>
                <th className="text-left py-4 px-6 text-xs font-bold text-slate-500 uppercase tracking-wider">Category</th>
                <th className="text-left py-4 px-6 text-xs font-bold text-slate-500 uppercase tracking-wider">Status</th>
                <th className="text-left py-4 px-6 text-xs font-bold text-slate-500 uppercase tracking-wider">Last Run</th>
                <th className="text-left py-4 px-6 text-xs font-bold text-slate-500 uppercase tracking-wider">Executions</th>
                <th className="text-left py-4 px-6 text-xs font-bold text-slate-500 uppercase tracking-wider">Success Rate</th>
                <th className="text-left py-4 px-6 text-xs font-bold text-slate-500 uppercase tracking-wider">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100 dark:divide-[#233c48]">
              {workflows.map((workflow) => (
                <tr key={workflow.id} className="hover:bg-slate-50 dark:hover:bg-[#1a2b35] transition-colors">
                  <td className="py-4 px-6">
                    <div>
                      <p className="text-white font-semibold text-sm">{workflow.name}</p>
                      <p className="text-slate-400 text-xs mt-1">{workflow.description}</p>
                    </div>
                  </td>
                  <td className="py-4 px-6">
                    <span className={`px-2 py-1 rounded-full text-xs font-bold ${getCategoryColor(workflow.category)}`}>
                      {workflow.category}
                    </span>
                  </td>
                  <td className="py-4 px-6">
                    <span className={`px-2 py-1 rounded-full text-xs font-bold capitalize ${getStatusColor(workflow.status)}`}>
                      {workflow.status}
                    </span>
                  </td>
                  <td className="py-4 px-6">
                    <span className="text-slate-400 text-sm">{workflow.lastRun}</span>
                  </td>
                  <td className="py-4 px-6">
                    <span className="text-white font-semibold">{workflow.executions.toLocaleString()}</span>
                  </td>
                  <td className="py-4 px-6">
                    <div className="flex items-center gap-2">
                      <span className="text-white font-semibold">{workflow.successRate}%</span>
                      <div className="w-16 bg-slate-200 dark:bg-[#233c48] h-1 rounded-full">
                        <div 
                          className="bg-emerald-500 h-full rounded-full" 
                          style={{width: `${workflow.successRate}%`}}
                        ></div>
                      </div>
                    </div>
                  </td>
                  <td className="py-4 px-6">
                    <div className="flex items-center gap-2">
                      <button className="text-slate-400 hover:text-primary p-1 rounded transition-colors">
                        <span className="material-symbols-outlined text-sm">play_arrow</span>
                      </button>
                      <button className="text-slate-400 hover:text-primary p-1 rounded transition-colors">
                        <span className="material-symbols-outlined text-sm">edit</span>
                      </button>
                      <button className="text-slate-400 hover:text-primary p-1 rounded transition-colors">
                        <span className="material-symbols-outlined text-sm">more_vert</span>
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyWorkflows;